import { useCallback, useEffect, useState } from 'react'

import { useAudioVideo } from 'amazon-chime-sdk-component-library-react'
import { DataMessage } from 'amazon-chime-sdk-js'

export const useMessaging = () => {
  const audioVideo = useAudioVideo()

  const [messages, setMessages] = useState<{ text: string; sender: string }[]>(
    []
  )
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    const messageHandler = (dataMessage: DataMessage) => {
      const text = new TextDecoder().decode(dataMessage.data)
      setMessages((msgs) => [...msgs, { text, sender: '他のユーザー' }])
    }

    // チャットメッセージの受信をセットアップ
    audioVideo?.start()
    audioVideo?.realtimeSubscribeToReceiveDataMessage('chat', messageHandler)

    return () => {
      audioVideo?.realtimeUnsubscribeFromReceiveDataMessage('chat')
    }
  }, [audioVideo])

  const sendMessage = useCallback(() => {
    try {
      if (message.trim()) {
        audioVideo?.realtimeSendDataMessage(
          'chat',
          new TextEncoder().encode(message.trim())
        )
        setMessages((msgs) => [
          ...msgs,
          { text: message.trim(), sender: 'あなた' },
        ])
        setMessage('')
      }
    } catch (e) {
      console.error(e) // eslint-disable-line no-console
    }
  }, [message, audioVideo])

  return {
    messages,
    message,
    setMessage,
    sendMessage,
  }
}
